import { render, staticRenderFns } from "./shopexerp.vue?vue&type=template&id=817b8dfc&scoped=true"
import script from "./shopexerp.vue?vue&type=script&lang=js"
export * from "./shopexerp.vue?vue&type=script&lang=js"
import style0 from "./shopexerp.vue?vue&type=style&index=0&id=817b8dfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817b8dfc",
  null
  
)

export default component.exports